export default "__VITE_ASSET__BUWwQcCm__"